import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
		Switch
	} from '@headlessui/vue'
	import { 
		clsx
	} from 'clsx'

	import {
		computed,
		inject,
		nextTick,
		ref
	} from 'vue'

	
	const __default__ = { name: 'VSwtich' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		modelValue: {
			type: Boolean,
			default: false
		},
		color: {
			type: String,
			default: "dark/zinc"
		},
		disabled: {
			type: Boolean,
			default: false
		},
		id: {
			type: String,
			default: ''
		}
	},
  emits: [
		'update:modelValue'
	],
  setup(__props, { emit }) {

const props = __props;

	

	const model = ref(props.modelValue)

	

	const enabled = computed(() => {
		return props.modelValue
	})

	const fieldDisabled = inject('fieldDisabled', computed(() => false))
	const fieldsetDisabled = inject('fieldsetDisabled', computed(() => false))
	const switchDisabled = computed(() => {
		return fieldDisabled.value || fieldsetDisabled.value || props.disabled
	})
	const controlId: string = inject('controlId', null) || props.id
	
	// update modeled value
	const onInput = async () => {
		if(switchDisabled.value) return
		emit('update:modelValue', model.value)
		await nextTick()
		return
	}
	
	const colors: {[ k: string ]: any} = {
		'dark/zinc': [
			'[--switch-bg-ring:theme(colors.zinc.950/90%)] [--switch-bg:theme(colors.zinc.900)] dark:[--switch-bg-ring:transparent] dark:[--switch-bg:theme(colors.white/25%)]',
			'[--switch-ring:theme(colors.zinc.950/90%)] [--switch-shadow:theme(colors.black/10%)] [--switch:white] dark:[--switch-ring:theme(colors.zinc.700/90%)]',
		],
		'dark/white': [
			'[--switch-bg-ring:theme(colors.zinc.950/90%)] [--switch-bg:theme(colors.zinc.900)] dark:[--switch-bg-ring:transparent] dark:[--switch-bg:theme(colors.white)]',
			'[--switch-ring:theme(colors.zinc.950/90%)] [--switch-shadow:theme(colors.black/10%)] [--switch:white] dark:[--switch-ring:transparent] dark:[--switch:theme(colors.zinc.900)]',
		],
		dark: [
			'[--switch-bg-ring:theme(colors.zinc.950/90%)] [--switch-bg:theme(colors.zinc.900)] dark:[--switch-bg-ring:theme(colors.white/15%)]',
			'[--switch-ring:theme(colors.zinc.950/90%)] [--switch-shadow:theme(colors.black/10%)] [--switch:white]',
		],
		zinc: [
			'[--switch-bg-ring:theme(colors.zinc.700/90%)] [--switch-bg:theme(colors.zinc.600)] dark:[--switch-bg-ring:transparent]',
			'[--switch-shadow:theme(colors.black/10%)] [--switch:white] [--switch-ring:theme(colors.zinc.700/90%)]',
		],
		white: [
			'[--switch-bg-ring:theme(colors.black/15%)] [--switch-bg:white] dark:[--switch-bg-ring:transparent]',
			'[--switch-shadow:theme(colors.black/10%)] [--switch-ring:transparent] [--switch:theme(colors.zinc.950)]',
		],
		red: [
			'[--switch-bg-ring:theme(colors.red.700/90%)] [--switch-bg:theme(colors.red.600)] dark:[--switch-bg-ring:transparent]',
			'[--switch:white] [--switch-ring:theme(colors.red.700/90%)] [--switch-shadow:theme(colors.red.900/20%)]',
		],
		orange: [
			'[--switch-bg-ring:theme(colors.orange.600/90%)] [--switch-bg:theme(colors.orange.500)] dark:[--switch-bg-ring:transparent]',
			'[--switch:white] [--switch-ring:theme(colors.orange.600/90%)] [--switch-shadow:theme(colors.orange.900/20%)]',
		],
		amber: [
			'[--switch-bg-ring:theme(colors.amber.500/80%)] [--switch-bg:theme(colors.amber.400)] dark:[--switch-bg-ring:transparent]',
			'[--switch-ring:transparent] [--switch-shadow:transparent] [--switch:theme(colors.amber.950)]',
		],
		yellow: [
			'[--switch-bg-ring:theme(colors.yellow.400/80%)] [--switch-bg:theme(colors.yellow.300)] dark:[--switch-bg-ring:transparent]',
			'[--switch-ring:transparent] [--switch-shadow:transparent] [--switch:theme(colors.yellow.950)]',
		],
		lime: [
			'[--switch-bg-ring:theme(colors.lime.400/80%)] [--switch-bg:theme(colors.lime.300)] dark:[--switch-bg-ring:transparent]',
			'[--switch-ring:transparent] [--switch-shadow:transparent] [--switch:theme(colors.lime.950)]',
		],
		green: [
			'[--switch-bg-ring:theme(colors.green.700/90%)] [--switch-bg:theme(colors.green.600)] dark:[--switch-bg-ring:transparent]',
			'[--switch:white] [--switch-ring:theme(colors.green.700/90%)] [--switch-shadow:theme(colors.green.900/20%)]',
		],
		emerald: [
			'[--switch-bg-ring:theme(colors.emerald.600/90%)] [--switch-bg:theme(colors.emerald.500)] dark:[--switch-bg-ring:transparent]',
			'[--switch:white] [--switch-ring:theme(colors.emerald.600/90%)] [--switch-shadow:theme(colors.emerald.900/20%)]',
		],
		teal: [
			'[--switch-bg-ring:theme(colors.teal.700/90%)] [--switch-bg:theme(colors.teal.600)] dark:[--switch-bg-ring:transparent]',
			'[--switch:white] [--switch-ring:theme(colors.teal.700/90%)] [--switch-shadow:theme(colors.teal.900/20%)]',
		],
		cyan: [
			'[--switch-bg-ring:theme(colors.cyan.400/80%)] [--switch-bg:theme(colors.cyan.300)] dark:[--switch-bg-ring:transparent]',
			'[--switch-ring:transparent] [--switch-shadow:transparent] [--switch:theme(colors.cyan.950)]',
		],
		sky: [
			'[--switch-bg-ring:theme(colors.sky.600/80%)] [--switch-bg:theme(colors.sky.500)] dark:[--switch-bg-ring:transparent]',
			'[--switch:white] [--switch-ring:theme(colors.sky.600/80%)] [--switch-shadow:theme(colors.sky.900/20%)]',
		],
		blue: [
			'[--switch-bg-ring:theme(colors.blue.700/90%)] [--switch-bg:theme(colors.blue.600)] dark:[--switch-bg-ring:transparent]',
			'[--switch:white] [--switch-ring:theme(colors.blue.700/90%)] [--switch-shadow:theme(colors.blue.900/20%)]',
		],
		indigo: [
			'[--switch-bg-ring:theme(colors.indigo.600/90%)] [--switch-bg:theme(colors.indigo.500)] dark:[--switch-bg-ring:transparent]',
			'[--switch:white] [--switch-ring:theme(colors.indigo.600/90%)] [--switch-shadow:theme(colors.indigo.900/20%)]',
		],
		violet: [
			'[--switch-bg-ring:theme(colors.violet.600/90%)] [--switch-bg:theme(colors.violet.500)] dark:[--switch-bg-ring:transparent]',
			'[--switch:white] [--switch-ring:theme(colors.violet.600/90%)] [--switch-shadow:theme(colors.violet.900/20%)]',
		],
		purple: [
			'[--switch-bg-ring:theme(colors.purple.600/90%)] [--switch-bg:theme(colors.purple.500)] dark:[--switch-bg-ring:transparent]',
			'[--switch:white] [--switch-ring:theme(colors.purple.600/90%)] [--switch-shadow:theme(colors.purple.900/20%)]',
		],
		fuchsia: [
			'[--switch-bg-ring:theme(colors.fuchsia.600/90%)] [--switch-bg:theme(colors.fuchsia.500)] dark:[--switch-bg-ring:transparent]',
			'[--switch:white] [--switch-ring:theme(colors.fuchsia.600/90%)] [--switch-shadow:theme(colors.fuchsia.900/20%)]',
		],
		pink: [
			'[--switch-bg-ring:theme(colors.pink.600/90%)] [--switch-bg:theme(colors.pink.500)] dark:[--switch-bg-ring:transparent]',
			'[--switch:white] [--switch-ring:theme(colors.pink.600/90%)] [--switch-shadow:theme(colors.pink.900/20%)]',
		],
		rose: [
			'[--switch-bg-ring:theme(colors.rose.600/90%)] [--switch-bg:theme(colors.rose.500)] dark:[--switch-bg-ring:transparent]',
			'[--switch:white] [--switch-ring:theme(colors.rose.600/90%)] [--switch-shadow:theme(colors.rose.900/20%)]',
		],
	}

	const focused = ref(false)
	const hovered = ref(false)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Switch), {
    id: _unref(controlId) ?? undefined,
    modelValue: model.value,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
      onInput
    ],
    "data-slot": "control",
    "data-checked": _unref(enabled) ? true : null,
    "data-disabled": _unref(switchDisabled) ? true : null,
    disabled: _unref(switchDisabled) ? true : false,
    "data-focus": focused.value ? true : null,
    "data-hover": hovered.value ? true : null,
    class: _normalizeClass(_unref(clsx)(
			// Base styles
			'group relative isolate inline-flex h-6 w-10 cursor-default rounded-full p-[3px] sm:h-5 sm:w-8',
			// Transitions
			'transition duration-0 ease-in-out data-[changing]:duration-200',
			// Outline and background color in forced-colors mode so switch is still visible
			'forced-colors:outline forced-colors:[--switch-bg:Highlight] dark:forced-colors:[--switch-bg:Highlight]',
			// Unchecked
			'bg-zinc-200 ring-1 ring-inset ring-black/5 dark:bg-white/5 dark:ring-white/15',
			// Checked
			'data-[checked]:bg-[--switch-bg] data-[checked]:ring-[--switch-bg-ring] dark:data-[checked]:bg-[--switch-bg] dark:data-[checked]:ring-[--switch-bg-ring]',
			// Focus
			'focus:outline-none data-[focus]:outline data-[focus]:outline-2 data-[focus]:outline-offset-2 data-[focus]:outline-blue-500',
			// Hover
			'data-[hover]:data-[checked]:ring-[--switch-bg-ring] data-[hover]:ring-black/15',
			'dark:data-[hover]:data-[checked]:ring-[--switch-bg-ring] dark:data-[hover]:ring-white/25',
			// Disabled
			'data-[disabled]:bg-zinc-200 data-[disabled]:data-[checked]:bg-zinc-200 data-[disabled]:opacity-50 data-[disabled]:data-[checked]:ring-black/5',
			'dark:data-[disabled]:bg-white/15 dark:data-[disabled]:data-[checked]:bg-white/15 dark:data-[disabled]:data-[checked]:ring-white/15',
			// Color specific styles
			colors[props.color]
		)),
    onFocusin: _cache[1] || (_cache[1] = ($event: any) => (focused.value = true)),
    onFocusout: _cache[2] || (_cache[2] = ($event: any) => (focused.value = false)),
    onMouseover: _cache[3] || (_cache[3] = ($event: any) => (hovered.value = true)),
    onMouseout: _cache[4] || (_cache[4] = ($event: any) => (hovered.value = false))
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", {
        "aria-hidden": "true",
        class: _normalizeClass(_unref(clsx)(
				// Basic layout
				'pointer-events-none relative inline-block size-[1.125rem] rounded-full sm:size-3.5',
				// Transition
				'translate-x-0 transition duration-200 ease-in-out',
				// Invisible border so the switch is still visible in forced-colors mode
				'border border-transparent',
				// Unchecked
				'bg-white shadow ring-1 ring-black/5',
				// Checked
				'group-data-[checked]:bg-[--switch] group-data-[checked]:shadow-[--switch-shadow] group-data-[checked]:ring-[--switch-ring]',
				'group-data-[checked]:translate-x-4 sm:group-data-[checked]:translate-x-3',
				// Disabled
				'group-data-[disabled]:group-data-[checked]:bg-white group-data-[disabled]:group-data-[checked]:shadow group-data-[disabled]:group-data-[checked]:ring-black/5'
			))
      }, null, 2)
    ]),
    _: 1
  }, 8, ["id", "modelValue", "data-checked", "data-disabled", "disabled", "data-focus", "data-hover", "class"]))
}
}

})